import type { Map } from 'immutable'
import { useSelector } from 'react-redux'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'
import { getIsAuthenticated } from 'selectors/auth'

export const sumQuantities = (recipes: Map<string, number>) =>
  recipes.reduce((total = 0, current = 0) => total + current, 0)

export const useRecipeLimitReached = (recipes: Map<string, number>): boolean => {
  const { numPortions } = useNumPortions()
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)
  const isAuthenticated = useSelector(getIsAuthenticated)

  return !isAuthenticated && sumQuantities(recipes) >= maxRecipesNum
}
